import React, { Component } from "react";
import { css } from "aphrodite/no-important";
import { styles } from "./ApplianceCostDiscStyles";
import Disc from "./Disc";

export default class ApplianceDisc extends Component {
  render() {
    return (
      <a
        href={`/${this.props.path}/appliance/${this.props.id}`}
        className={css(styles.container)}
      >
        <span className={css(styles.order)}>{this.props.order}</span>
        <div className={css(styles.discWrapper)}>
          <Disc {...this.props} />
        </div>
        <div className={css(styles.textContainer)}>
          <span className={css(styles.title)}>{this.props.title}</span>
          <span className={css(styles.cost)}>{this.props.cost}</span>
          <span className={css(styles.separator)}>&#183;</span>
          <span className={css(styles.rate)}>{this.props.rate}</span>
        </div>
      </a>
    );
  }
}
